import { Sparkles, Droplets, AlertTriangle, Eye, MapPin, Loader2, Hourglass } from "lucide-react";

const SPIA = {
  pulito: { c: "#10B981", I: Sparkles },
  osservare: { c: "#F59E0B", I: Eye },
  pulizia: { c: "#EF4444", I: Droplets },
  da_verificare: { c: "#94A3B8", I: AlertTriangle },
  senza_posizione: { c: "#94A3B8", I: MapPin },
  in_corso: { c: "#38BDF8", I: Loader2 },
  in_attesa: { c: "#94A3B8", I: Loader2 },
};

// Spia "Pulizia pannelli" con il perché (testo già adattato a cliente o installatore dal backend)
export function PuliziaCard({ d, dark, children, onClick }) {
  if (!d) return null;
  const s = SPIA[d.spia] || SPIA.in_attesa;
  const gira = d.spia === "in_corso";
  return (
    <section onClick={onClick} role={onClick ? "button" : undefined} className={`rounded-3xl p-5 ${onClick ? "cursor-pointer transition-transform active:scale-[0.99]" : ""} ${dark ? "border border-neutral-800 bg-neutral-900" : "bg-white shadow-sm ring-1 ring-slate-100"}`} data-testid="pulizia-card">
      <div className={`mb-3 text-[11px] font-bold uppercase tracking-widest ${dark ? "text-neutral-400" : "text-slate-400"}`}>Pulizia pannelli</div>
      <div className="flex items-start gap-3">
        <span className="relative mt-0.5 flex h-11 w-11 shrink-0 items-center justify-center rounded-full" style={{ background: `${s.c}22`, color: s.c }} data-testid={`pulizia-spia-${d.spia}`}>
          <s.I className={`h-5 w-5 ${gira ? "animate-spin" : ""}`} />
          {["pulito", "osservare", "pulizia"].includes(d.spia) && <span className={`absolute -right-0.5 -top-0.5 h-3 w-3 rounded-full ring-2 ${dark ? "ring-neutral-900" : "ring-white"}`} style={{ background: s.c }} />}
        </span>
        <div className="min-w-0 flex-1">
          <b className={`block text-base font-extrabold ${dark ? "text-white" : "text-slate-800"}`} data-testid="pulizia-titolo">{d.titolo}</b>
          {d.preliminare && <span className={`mt-1 inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider ${dark ? "bg-sky-400/15 text-sky-300" : "bg-sky-50 text-sky-600 ring-1 ring-sky-100"}`} data-testid="pulizia-preliminare-badge"><Hourglass className="h-3 w-3" />Stima preliminare</span>}
          <p className={`mt-1 text-sm leading-relaxed ${dark ? "text-neutral-300" : "text-slate-600"}`} data-testid="pulizia-perche">{d.perche}</p>
          {d.aggiornato_il && <span className={`mt-2 block text-[11px] ${dark ? "text-neutral-500" : "text-slate-400"}`}>Aggiornato il {new Date(d.aggiornato_il).toLocaleDateString("it-IT")}{onClick && <b className="ml-2 font-bold uppercase tracking-wider text-sky-600">Vedi andamento ›</b>}</span>}
        </div>
      </div>
      {children}
    </section>
  );
}
